module.exports = __webpack_public_path__ + "img/news_head_1.00130ba6.jpg";